module.exports = __webpack_public_path__ + "img/6品牌建设.ad0e4067.png";